import {
  Component,
  ViewEncapsulation,
  input
} from '@angular/core';

import { AnimationOptions } from 'ngx-lottie';
import { LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'isc-lottie-animation',
  imports: [LottieComponent],
  templateUrl: './lottie-animation.html',
  styleUrl: './lottie-animation.scss',
})
export class LottieAnimation {

  options = input.required<AnimationOptions>();

  height = input<string>('500px');

  width = input<string>('500px');
}
